
import React, { useEffect, useState } from 'react';

const Overlay = ({ config, type, score }) => {

    const [highscore, setHighscore] = useState(false);

    useEffect(() => {
            let storedScores = JSON.parse(sessionStorage.getItem("storedScores") || "[]");
            storedScores = storedScores.sort((a, b) => b.date - a.date).sort((a, b) => b.score - a.score).filter((score, id) => {
                if (id <= 9) {
                    return true;
                }
                return false;
            });

            if ((score >= storedScores[storedScores.length - 1] && storedScores[storedScores.length - 1].score) || (storedScores.length < 10 && score > 0)) {
                setHighscore(true);
            }

        // eslint-disable-next-line
    }, [type]);

    return (

        <div className="overlay hide">
            {type === 'level-complete' &&
                <span className="level-complete">{config.level_complete_text}</span>
            }

            {type === 'game-over' &&
                <span className="game-over">{config.game_over_text}</span>
            }

            {type === 'game-over' && highscore &&
                <span className="highscore">{config.highscore_text}</span>
            }
        </div>
    )
};

export default Overlay;
